/* eslint-disable no-unused-expressions,no-unused-vars */
/* global PLATFORM, G */
import map from 'lib/sequence/model/api/map'
import { asyncPipeSpread, asyncPipeSpreadIf, bulk } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { disable, enable } from 'lib/sequence/component/state/disabled'

/**
 * Presets the device's location
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const mapProperties = module => async (components, ...args) => {
  // model
  const { licence: model } = module[G.MODEL][G.CHILDREN]
  const bulkMap = bulk(map(model))

  const { licenceInfo, details } = components
  bulkMap(licenceInfo, details)

  return [components, ...args]
}

/**
 * Displays the QR code button based on the length of the licence key.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const displayDownloadButton = module => async (components, ...args) => {
  const { licence: model } = module[G.MODEL][G.CHILDREN]

  const { btnQRCode } = components

  model[G.CACHE]?.value?.licenseKey?.length > 0
    ? enable(btnQRCode)
    : disable(btnQRCode)

  return [components, ...args]
}

/**
 * ServiceItem Detail Action
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  mapProperties(module),
  asyncPipeSpreadIf(() => PLATFORM === 'web')(
    displayDownloadButton(module),
  ),
)(find(component), ...args)
